import { useQueryClient } from "@tanstack/react-query";
import { PENDING_REQUESTS_KEY } from "./constants";

export const usePendingRequestsActions = () => {
  const queryClient = useQueryClient();

  //  for reftching the pending requests after approval/rejection and showing the updated count in the drawer header without refreshing the page
  const refreshPendingRequests = async () => {
    return queryClient.invalidateQueries({
      queryKey: PENDING_REQUESTS_KEY,
      refetchType: "all",
    });
  };

  return {
    refreshPendingRequests,
  };
};
